import { getFormattedProduct } from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useTrackShareProduct = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const trackShareProductEvent = useCallback(
    (product) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        if (product) {
          window.webengage.track("share_product", getFormattedProduct(product));
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { trackShareProductEvent };
};

export default useTrackShareProduct;
